import {useCallback, useContext, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {ImageSize} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/ImageSize/ImageSize';
import {UploadButton} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/UploadButton/UploadButton';
import {DoneButton} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/UyoControl/Done/DoneButton';
import {UyoImageRotate} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/UyoControl/Rotate/UyoImageRotate';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {DeleteButton} from '../DeleteButton/DeleteButton';
import {Header} from '~/common/fabric/Card/components/Header/Header';
import {ResetImageXY} from '../ResetImageXY/ResetImageXY';
import {UPDATE_PRISTINE_UYO} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import './UyoControl.sass';

export const UyoControl = ({editorDisabled}) => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const dispatch = useDispatch();
  const [id, setId] = useState(null);
  const [uyoImage, setUyoImage] = useState(null);

  useEffect(() => {
    if (activeObjects?.[0]?.type === 'uYOImage') {
      setUyoImage(activeObjects[0]);
      setId(activeObjects[0].id);
    }
  }, [activeObjects]);

  const imageUploadedCallback = useCallback(
    (uploadedUyo) => {
      dispatch({
        type: UPDATE_PRISTINE_UYO,
        payload: {pristineUyo: false, id, objects: canvas.getObjects()},
      });
      canvas.setActiveObject(uploadedUyo).renderAll();
    },
    [canvas]
  );

  return (
    <div key={id} className={`uyo_control-container ${editorDisabled ? 'disabled' : ''}`}>
      <Header
        title="Photo Editor"
        extra={
          <ResetImageXY
            disabled={editorDisabled}
            label="Reset Position"
            dataQaId="step1-imagexy-reset"
            uyoImage={uyoImage}
            key={id}
          />
        }
      />
      <div className="uyo_control__edit-actions">
        <ImageSize id={id} />
        <UyoImageRotate btnText="Rotate" disabled={editorDisabled} />
      </div>
      <div className="uyo_control__remove-actions">
        <UploadButton
          showFullWidth
          btnText="Upload New"
          id={id}
          index={id}
          callback={imageUploadedCallback}
        />
        <DeleteButton btnText="Remove Current" disabled={editorDisabled} />
      </div>
      <DoneButton />
    </div>
  );
};
